export enum CreateCustomerModalTypes {
  CREATE_CUSTOMER = 'createCustomer',
  EDIT_CUSTOMER = 'editCustomer'
}
